import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

export const additionalTaxInformationFields: FieldInterface[] = [
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
    enumType: 'AdditionalTaxInformationKinds',
    enumTypePath:
      'src/tpbp-core/models/addition-tax-information/additional-tax-information.type',
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'year',
    originKey: 'year',
    type: FIELD_TYPES.integer,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'amount',
    originKey: 'amount',
    type: FIELD_TYPES.integer,
  },
]

export const additionalTaxInformationRelations: RelationInterface[] = []
